import React, { useState, useEffect } from 'react';
import logComponent from '../../common/logComponent';
import './OrgActionPanel.css';
import OrgRejectionPanel from './OrgRejectionPanel';

export default function OrgActionPanel({ updateStatus, cancel, accept, organization }) {
  const [updateStart, setUpdateStart] = useState(true);
  const [rejectionStart, setRejectionStart] = useState(true);
  const [dismissalTimeout, setDismissalTimeout] = useState(true);
  const [currentDisplay, setCurrentDisplay] = useState('initial');
  const [currentMessage, setCurrentMessage] = useState(true);

  if (logComponent('OrgActionPanel')) { console.debug('OrgActionPanel rendered'); }

  useEffect(() => {
    if (logComponent('OrgActionPanel')) { console.debug('OrgActionPanel useEffect [updateStatus]'); }
    if (updateStatus === 'updating') {
      showPendingMessage();
    } else if ((updateStatus === 'updated' || updateStatus === 'failed')) {
      const elapsedTime = Date.now() - updateStart;

      if (elapsedTime > 1500) {
        showResultMessage();
      } else {
        setTimeout(() => {
          showResultMessage();
        }, 1500 - elapsedTime);
      }

    }
  }, [updateStatus])


  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('OrgActionPanel')) { console.debug('OrgActionPanel onMount'); }
    return () => {
      if (dismissalTimeout) {
        clearTimeout(dismissalTimeout);
      }
    };
  }, []);


  const beginRejection = () => {
    if (logComponent('OrgActionPanel')) { console.debug('OrgActionPanel beginRejection'); }
    setCurrentDisplay('rejection');
  }

  const showPendingMessage = () => {
    if (logComponent('OrgActionPanel')) { console.debug('OrgActionPanel showPendingMessage'); }
    setCurrentDisplay('messages');
    setCurrentMessage('updating');
    setUpdateStart(Date.now());
  }

  const showResultMessage = () => {
    if (logComponent('OrgActionPanel')) { console.debug('OrgActionPanel showResultMessage'); }
    setCurrentMessage(updateStatus);
    setUpdateStart(null);

    if (updateStatus === 'updated') {
      setDelayedDismissal();
    }
  }

  const setDelayedDismissal = () => {
    if (logComponent('OrgActionPanel')) { console.debug('OrgActionPanel setDelayedDismissal'); }
    setDismissalTimeout(setTimeout(() => {
      cancel();
    }, 1500));
  }

  const refresh = () => {
    if (logComponent('OrgActionPanel')) { console.debug('OrgActionPanel refresh'); }
    setCurrentDisplay('initial');
    setCurrentMessage(null);
  }

  return (
    <div className="Org-Action-Panel">
      {
        currentDisplay === 'initial' &&
        <div className="Org-Action-Panel__buttons">
          <button
            className="Org-Action-Panel__accept"
            onClick={accept}>Accept</button>
          <button
            className="Org-Action-Panel__reject"
            onClick={beginRejection}>Reject</button>
          <button
            className="Org-Action-Panel__cancel"
            onClick={cancel}>Cancel</button>
        </div>
      }
      {
        currentDisplay === 'rejection' &&
        <OrgRejectionPanel
          organization={organization}
          dismiss={refresh}
          dismissParent={cancel} />
      }
      {
        currentDisplay === 'messages' &&
        <div className="Org-Action-Panel__messages">
          {
            currentMessage === 'updating' &&
            <p className="Org-Action-Panel__pending">Attempting to add {organization.name} to the {organization.uiData.type} database...</p>
          }
          {
            currentMessage === 'updated' &&
            <button
              className="Org-Action-Panel__success"
              onClick={cancel}>Successfully added {organization.name}! Click to dismiss.</button>
          }
          {
            currentMessage === 'failed' &&
            <button
              className="Org-Action-Panel__failure"
              onClick={refresh}>Failed to add {organization.name}. Click to try again.</button>
          }
        </div>
      }
    </div>
  );
}